import { render } from "./Category.vue?vue&type=template&id=09607d4f&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=09607d4f&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09607d4f"]])

export default __exports__